import { render, staticRenderFns } from "./OrdersAlgolia.vue?vue&type=template&id=8f669616&scoped=true"
import script from "./OrdersAlgolia.vue?vue&type=script&lang=js"
export * from "./OrdersAlgolia.vue?vue&type=script&lang=js"
import style0 from "./OrdersAlgolia.vue?vue&type=style&index=0&id=8f669616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f669616",
  null
  
)

export default component.exports